<template>
    <v-card-text>
        <v-container fluid grid>
            <v-row dense>
                <v-col id="gastosCubiertos" cols="12" sm="12">
                    <v-row dense>
                        <v-col cols="12">
                            <ModalInformacionComponent :titulo="obModal.titulo" :open="obModal.open"
                                :descripcion="obModal.descripcion" />
                        </v-col>
                    </v-row>

                    <v-row dense align="center" justify="center">
                        <v-col cols="12" sm="8">
                            <div class="text-center">
                                <h1 class="titleSection">Gastos cubiertos</h1>
                            </div>
                            <div class="text-center mt-3">
                                <p class="contenido">
                                    Estos son los montos que te pagaremos si tu o alguien más se accidenta en tu
                                    auto.
                                </p>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row v-if="!$root.isTouch" dense align="center" justify="center">
                        <v-col cols="12" sm="4" class="mt-3"
                            v-for="(v,k) in _.orderBy(_.filter(listCobertura,{mostrar_cliente:'1'}),['orden'],['asc'])" :key="k">
                            <div class="wrapGastCub">
                                <div class="text-center">
                                    <v-img contain height="60px" max-height="60px" :src="v.base64"></v-img>
                                </div>

                                <h5 class="titleGastCub mt-3 text-center" v-html="v.cobertura"></h5>
                                <p class="contenido">
                                    {{ v.definicion_corta }}
                                    <a class="linkRed" @click="verDetalle(v)">Ver Detalles</a>
                                </p>
                                <p class="contenido" v-show="_.toNumber(v.id_cobertura) == 1">
                                    {{ leyenda1 }}
                                    <a class="linkRed" @click="next(false)">haz click aquí</a>
                                </p>
                                <div class="text-center mb-3">
                                    <VueNumberInput v-model="v.valor_cobertura_old" :readonly="true" size="small" inline rounded center/>
                                </div>
                                <div v-if="_.toNumber(v.id_cobertura) == parametros.id_cobertura_todo_riesgo_wizard" class="text-center">
                                    <VueNumberInput v-model="v.valor_cobertura" :min="v.rango_inicial"
                                        :max="v.rango_final" :step="v.rango_intervalo" inline 
                                        size="small" rounded center @change="changeValorCobertura(v)"/>

                                    <div style="margin: -0.2rem;">
                                        <a id="volverValor" class="overline linkRedValorRecomendado"
                                            @click="volverValorRecomendado(v)">VOLVER AL VALOR RECOMENDADO</a>
                                    </div>
                                </div>
                                <div v-else class="text-center">
                                    <VueNumberInput v-model="v.valor_cobertura" :min="v.rango_inicial"
                                        :max="v.rango_final" :step="v.rango_intervalo" inline controls 
                                        size="small" rounded center :inputtable="false"
                                        @change="changeValorCobertura(v)"/>
                                    <div style="margin: -0.2rem;">
                                        <a id="volverValor" class="overline linkRedValorRecomendado"
                                            @click="volverValorRecomendado(v)">VOLVER AL VALOR RECOMENDADO</a>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row v-else>
                        <v-col cols="12" class="mt-3">
                            <v-row dense>
                                <v-col cols="12" sm="4" v-for="(v,k) in _.orderBy(_.filter(listCobertura,{mostrar_cliente:'1'}),['orden'],['asc'])"
                                    :key="k">
                                    <div class="wrapGastCub" style="height:310px;min-height:310px !important">
                                        <div class="text-center">
                                            <v-tooltip top dark max-width="80%">
                                                <template v-slot:activator="{ on }">
                                                    <v-img contain height="60px" max-height="60px" :src="v.base64"
                                                        v-on="on"></v-img>
                                                </template>
                                                <p class="contenidoServIncl body-2 white--text"
                                                    v-html="v.definicion_corta" />
                                            </v-tooltip>
                                        </div>

                                        <div class="text-center">
                                            <h5 class="titleGastCub mt-3 text-center" v-html="v.cobertura"></h5>
                                            <a class="linkRed" @click="verDetalle(v)">Ver Detalles</a>
                                        </div>
                                        <!-- <p class="contenido" v-show="_.toNumber(v.id_cobertura) == 1">
                                            {{ leyenda1 }}
                                            <a class="linkRed" @click="next(false)">haz click aquí</a>
                                        </p> -->
                                        <div class="text-center mt-2 mb-3">
                                            <VueNumberInput v-model="v.valor_cobertura_old" :readonly="true" size="small" inline center rounded/>
                                        </div>
                                        <div v-if="_.toNumber(v.id_cobertura) == parametros.id_cobertura_todo_riesgo_wizard" class="text-center">
                                            <VueNumberInput v-model="v.valor_cobertura" :min="v.rango_inicial"
                                                :max="v.rango_final" :step="v.rango_intervalo" inline 
                                                size="small" rounded center @change="changeValorCobertura(v)"/>

                                            <div style="margin: -0.2rem;">
                                                <a id="volverValor" class="overline linkRedValorRecomendado"
                                                    @click="volverValorRecomendado(v)">VOLVER AL VALOR RECOMENDADO</a>
                                            </div>
                                        </div>
                                        <div v-else class="text-center">
                                            <VueNumberInput v-model="v.valor_cobertura" :min="v.rango_inicial"
                                                :max="v.rango_final" :step="v.rango_intervalo" inline controls 
                                                size="small" rounded center :inputtable="false"
                                                @change="changeValorCobertura(v)"/>
                                            <div style="margin: -0.2rem;">
                                                <a id="volverValor" class="overline linkRedValorRecomendado"
                                                    @click="volverValorRecomendado(v)">VOLVER AL VALOR RECOMENDADO</a>
                                            </div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- <pre>{{ listCobertura }} </pre> -->

                    <v-row dense class="mt-3 mb-3" align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-icon color="secundary" class="btnNext" @click="siguiente">arrow_forward</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    import VueNumberInput from '@chenfengyuan/vue-number-input';
    export default {
        name: 'windowGastosCobiertosComponent',
        components:{
            ModalInformacionComponent: () => import('./ModalInformacionComponent.vue'),
            VueNumberInput
        },
        inject:['next','updateData','recalcularPrima'],
        props: {
            listCoberturaActual: {
                type: Array,
                default: () => []
            },
            listCoberturaNueva: {
                type: Array,
                default: () => []
            },
            stepper: {
                type: Number,
                default: 2
            },
            obSeguro: {
                type: Object,
                default: {}
            },
            parametros: {
                type: Object,
                default: {}
            }
        },
        data: () => ({
            listCobertura: [],
            obModal:{
                titulo:'',
                open:false,
                descripcion:''
            },
            band: false,
            leyenda1: ' Si deseas incluir el valor adicional de otros artículos que no son de fábrica como altoparlantes, aros personalizados, etc,'
        }),
        created() {
            this.band = true;
            this.$set(this, 'listCobertura', _.cloneDeep(this.listCoberturaNueva));
        },
        watch: {
            stepper(val) {
                if (val == 2) {
                    this.$set(this, 'listCobertura', _.cloneDeep(this.listCoberturaNueva));
                }
            }
        },
        methods:{
            changeValorCobertura(o){
                if(!this.band){
                    var idClasificacion = this.parametros.id_clasificacion_cobertura_accidentes_personales;
                    var lista = _.cloneDeep(this.listCobertura);

                    // Se valida que el valor de la cobertura este en el rango min y max
                    if(o.valor_cobertura > o.rango_final)
                        o.valor_cobertura = o.rango_final;
                    else if(o.rango_inicial > o.valor_cobertura)
                        o.valor_cobertura = o.rango_inicial;
                    
                    var index = _.findIndex(lista,{'index':o.index});
                    lista[index] = _.merge(lista[index],o);
                    
                    // Se suma las coberturas de los gastos médicos
                    if(o.valor_cobertura != o.valor_cobertura_n && o.id_clasificacion_cobertura == idClasificacion){
                        var sum = o.valor_cobertura > o.valor_cobertura_n ? true : false;                        
                        lista = _.map(lista,(v)=>{
                                        if(v.id_clasificacion_cobertura == idClasificacion && v.id_cobertura != o.id_cobertura){
                                            v.valor_cobertura= sum ? (v.valor_cobertura+v.rango_intervalo) : (v.valor_cobertura-v.rango_intervalo);
                                            v.valor_cobertura_n = v.valor_cobertura;
                                        }
                                    return v;
                                });
                    }                

                    this.updateData('objForm.objInfoSeguroRenovacion.coberturas',lista);
                    this.recalcularPrima(false);
                }
            },
            volverValorRecomendado(o){
                this.band = true;

                new Promise((resolve,reject)=>{
                    var lista = _.cloneDeep(this.listCobertura);
                    var idClasificacion = this.parametros.id_clasificacion_cobertura_accidentes_personales;
    
                    if(o.id_clasificacion_cobertura == idClasificacion){
                        lista = _.filter(_.clone(lista),{'id_clasificacion_cobertura':idClasificacion});
    
                        lista = _.map(lista,(v) =>{
                                            v.valor_cobertura = v.valor_recomendado;
                                            v.valor_cobertura_n = v.valor_recomendado;
                                        return v;
                                });
                    }else{
                        var index = _.findIndex(lista,{'index':o.index});
                        lista[index].valor_cobertura = lista[index].valor_recomendado;
                        lista[index].valor_cobertura_n = lista[index].valor_recomendado;
                    }

                    return resolve({'error':false,'data':lista});
                })
                .then((r)=>{
                    if(r.error) throw 'Error al volver a valor recomendado';
                        this.listCobertura = _.unionBy(r.data,_.cloneDeep(this.listCobertura),"index");
                        this.updateData('objForm.objInfoSeguroRenovacion.coberturas',this.listCobertura);
                        this.recalcularPrima(false);

                        return r;
                })
                .then((r)=>{
                    this.band = false;
                })
                .catch((e)=>{
                    mensajesAlerta(e,'E');
                })

            },
            siguiente(){
                this.updateData('objForm.objInfoSeguroRenovacion.coberturas',this.listCobertura);
                this.next();
            },
            verDetalle(objeto){
                this.obModal = {
                    titulo: objeto.cobertura,
                    descripcion: objeto.definicion_extensa,
                    open: true
                };
            },
            close(){
                this.obModal = {
                    titulo:'',
                    open: false,
                    descripcion:''
                };
            },
        },
        mounted(){
            this.band = false;
        },
        provide(){
            return{
                close: this.close
            }
        }
    }
</script>

<style >
    .wrapGastCub {
        margin: 0 5px !important;
        background: #F4F4F4;
        padding: 20px;
        border-radius: 50px;
        min-height: 380px;
        height: 450px;
    }

    h5.titleGastCub {
        font-size: 1rem;
        letter-spacing: 2px;
        color: #898989;
        font-weight: 700;
        text-transform: none;
    }

    #volverValor:hover {
        text-decoration: underline;
    }

    #volverValor:active {
        text-decoration: underline;
    }

    /* ******* */
    input[type="number"] {
        -webkit-appearance: textfield;
        -moz-appearance: textfield;
        appearance: textfield;
    }
    
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
    }

    .number-input {
        /* border: 2px solid #b3b3b3;  */
        display: inline-flex;
    }
    
    .number-input,
    .number-input * {
        box-sizing: border-box;
        border-radius: 25px;
        background: transparent;
    }

    .number-input--inline {
        border: 1.5px solid #b3b3b3;
    }

    .number-input button {
        outline:none;
        -webkit-appearance: none;
        background-color: transparent !important;
        border: none;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 1.5rem;
        cursor: pointer;
        margin: 0;
        position: relative;
    }

    .number-input button:before,
    .number-input button:after {
        display: inline-block;
        position: absolute;
        content: '';
        width: 0.7rem !important;
        height: 2px !important;
        background-color: #ff4132 !important;
        /* background-color: red !important;  */
        transform: translate(-50%, -50%);
    }

    .number-input button.number-input__button--plus:after {
        transform: translate(-50%, -50%) rotate(90deg) !important;
    }
    
    .number-input input[type=number] {
        font-family: sans-serif;
        /* max-width: 5rem;  */
        padding: .5rem;
        border: 0;
        border-width: 0 2px;
        font-size: 0.7rem;
        height: 1.5rem;
        font-weight: bold;
        text-align: center;
    }
</style>